/** Only campaign metadata may cross from the marketing site to registration. */
const FIELD_LIMITS: Record<string, number> = {
  utm_source: 120,
  utm_medium: 120,
  utm_campaign: 200,
  utm_term: 200,
  utm_content: 200,
  gclid: 255,
  gbraid: 255,
  wbraid: 255,
  fbclid: 255,
  // Partner code from a partner link (`?ref=`); the app attributes the sign-up to it.
  ref: 64,
};

/** Partner codes are lowercase slugs; anything else is dropped, never "fixed". */
const REF_PATTERN = /^[a-z0-9][a-z0-9-]{0,62}[a-z0-9]$/;

/** Drop arbitrary query parameters, empty values and control characters. */
export function campaignQuery(search: string): string {
  const source = new URLSearchParams(search);
  const result = new URLSearchParams();
  for (const [key, limit] of Object.entries(FIELD_LIMITS)) {
    // eslint-disable-next-line no-control-regex -- explicitly strip untrusted control characters
    const value = source.get(key)?.replace(/[\u0000-\u001f\u007f]/g, "").trim();
    if (key === "ref" && value && !REF_PATTERN.test(value.toLowerCase())) continue;
    if (value) result.set(key, (key === "ref" ? value.toLowerCase() : value).slice(0, limit));
  }
  return result.toString();
}

/** Keep a touch across ordinary SPA navigation, never mix two ad click IDs. */
export function nextCampaignQuery(previous: string, search: string): string {
  return campaignQuery(search) || previous;
}

/** Fill missing attribution fields without wiping an existing ad click. */
export function withAttribution(previous: string, extra: string): string {
  const merged = new URLSearchParams(campaignQuery(previous.startsWith("?") ? previous : `?${previous}`));
  const add = new URLSearchParams(campaignQuery(extra.startsWith("?") ? extra : `?${extra}`));
  for (const [key, value] of add.entries()) {
    if (value && !merged.get(key)) merged.set(key, value);
  }
  return merged.toString();
}

/** Registration destinations are fixed; query input cannot override the host. */
export function googleRegistrationUrl(language: string, campaign: string): string {
  const domains: Record<string, string> = { sk: "sk", cs: "cz", da: "dk", en: "com", de: "de" };
  const url = new URL(`https://app.bidmio.${domains[language] || "com"}/register/step1`);
  url.search = campaignQuery(campaign);
  return url.toString();
}
